<template>
  <v-main class="bg-background" scrollable>
    <div v-if="isLoading">
      <v-progress-linear color="border" indeterminate />
    </div>
    <div
      v-if="jiraIssue && Object.keys(jiraIssue).length > 0 && !isLoading"
      class="pa-4 h-100 d-flex justify-center"
      data-testid="so-page-issue"
    >
      <div class="w-75 d-flex flex-column justify-start gap-4">
        <IssueHeader :jira-issue="jiraIssue" />
        <JiraIssueAttachments :attachments="jiraIssue.fields.attachment" />
        <JiraIssueLinks
          v-if="jiraIssue.fields.issuelinks.length > 0"
          :issue-links="jiraIssue.fields.issuelinks"
        />

        <SoDivider class="mt-5 mb-5" />

        <div class="d-flex align-center justify-space-between">
          <h5 class="font-weight-bold font-size-align">Activity</h5>
          <SoButton
            data-testid="issue-view-all-incidents"
            title="All Bugs and Incidents"
            type="secondary"
            icon="arrow-right"
            large
            :to="{ name: 'Issues' }"
          />
        </div>
        <JiraIssueComments :comments="jiraIssue.fields.comment.comments" />
      </div>
    </div>
  </v-main>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { JiraIssuesService } from "@/services/JiraIssuesService"
  import { useRoute } from "vue-router"
  import dayjs from "dayjs"
  import JiraIssueAttachments from "@/views/customer/issues/components/JiraIssueAttachments.vue"
  import JiraIssueLinks from "@/views/customer/issues/components/JiraIssueLinks.vue"
  import IssueHeader from "@/views/customer/issues/components/IssueHeader.vue"
  import JiraIssueComments from "@/views/customer/issues/components/JiraIssueComments.vue"
  import SoDivider from "@/components/SoDivider.vue"

  export default defineComponent({
    components: {
      SoDivider,
      JiraIssueComments,
      IssueHeader,
      JiraIssueLinks,
      JiraIssueAttachments,
      SoButton,
    },
    data() {
      return {
        incidentId: "",
      }
    },
    computed: {
      fetchJiraIssue() {
        return JiraIssuesService.getJiraIssue(this.incidentId)
      },
      jiraIssue() {
        return this.fetchJiraIssue.data
      },
      isLoading() {
        return this.fetchJiraIssue.isFetching
      },
      isError() {
        return this.fetchJiraIssue.error
      },
    },
    created() {
      const route = useRoute()
      this.incidentId = route.params.issueId as string
    },
    methods: { dayjs },
  })
</script>
